// clientes-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Abastecimento": "Carga de combustible",
    "Acesso": "Acceso",
    "Adicionar Cupom": "Agregar Cupón",
    "Adicionar Pontos": "Agregar Puntos",
    "Anotado por": "Anotado por",
    "Anotação": "Anotación",
    "Anotações": "Anotaciones",
    "Anúncios Visualizados": "Anuncios Visualizados",
    "Atualizado por": "Actualizado por",
    "Avaliação": "Evaluación",
    "Avaliação do frentista": "Evaluación del playero",
    "Bairro": "Barrio",
    "Bico": "Pico",
    "Bloqueado": "Bloqueado",
    "Bloqueado por": "Bloqueado por",
    "Brinde": "Premio",
    "Buscar": "Buscar",
    "CEP": "Código Postal",
    "Cadastrado em": "Registrado el",
    "Cadastrar novo cliente": "Registrar nuevo cliente",
    "Campos": "Campos",
    "Cidade": "Ciudad",
    "Cliente Indicado": "Cliente Referido",
    "Clientes da rede": "Clientes de la red",
    "Combustíveis:": "Combustibles:",
    "Comentário": "Comentario",
    "Complemento": "Complemento",
    "Confirmar Senha": "Confirmar Contraseña",
    "Conquistas": "Logros",
    "Coupons": "Cupones",
    "Código do Brinde": "Código del Premio",
    "Código:": "Código:",
    "Dados pessoais": "Datos personales",
    "Data da Indicação": "Fecha de la Referencia",
    "Data da visualização": "Fecha de la visualización",
    "Data de Nascimento": "Fecha de Nacimiento",
    "Data de troca": "Fecha de canje",
    "Data do Abastecimento": "Fecha de la Carga de Combustible",
    "Data do Reembolso": "Fecha del Reembolso",
    "Data e Hora": "Fecha y Hora",
    "Desconto Combustível": "Descuento Combustible",
    "Direito ao Palpite": "Derecho al Pronóstico",
    "Dispositivo": "Dispositivo",
    "Editar cliente": "Editar cliente",
    "Em aberto": "Abiertas",
    "Empresa": "Empresa",
    "Endereço": "Dirección",
    "Enviar notificação": "Enviar notificación",
    "Erro ao iniciar reprocessamento": "Error al iniciar el reprocesamiento",
    "Estado": "Estado",
    "Etiqueta": "Etiqueta",
    "Expira em": "Expira el",
    "Extrato": "Extracto",
    "Fechadas": "Cerradas",
    "Ganhou em": "Ganó el",
    "Gerado às": "Generado a las",
    "Giro na Roleta": "Giro en la Ruleta",
    "Girou em:": "Giró el:",
    "Grupo": "Grupo",
    "Grupos foram substituídos por etiquetas — use o campo Etiquetas abaixo.": "Los grupos fueron reemplazados por etiquetas — use el campo Etiquetas a continuación.",
    "Jogo:": "Juego:",
    "Litros": "Litros",
    "Local de Retirada": "Lugar de Retiro",
    "Logs": "Logs",
    "Logs da AWS": "Logs de AWS",
    "Marca": "Marca",
    "Modelo": "Modelo",
    "Motivo da Recompensa": "Motivo de la Recompensa",
    "Nenhum item foi encontrado": "No se encontró ningún elemento",
    "Nenhum resultado encontrado": "No se encontraron resultados",
    "Nenhuma conquista registrada para este cliente": "No hay logros registrados para este cliente",
    "Nenhuma recompensa disponível": "Ninguna recompensa disponible",
    "Nome do Brinde": "Nombre del Premio",
    "Não Bloqueados": "No Bloqueados",
    "Não há abastecimento": "No hay carga de combustible",
    "Não informado": "No informado",
    "Número": "Número",
    "Número do cupom": "Número del cupón",
    "Observações": "Observaciones",
    "Outro": "Otro",
    "Placa": "Patente",
    "Posto não identificado": "Estación no identificada",
    "Premiado": "Premiado",
    "Preço com desconto": "Precio con descuento",
    "Preço normal": "Precio normal",
    "Promoter": "Promotor",
    "R$ 0,000": "R$ 0,000",
    "Regerar rastreamento de pontos": "Regenerar seguimiento de puntos",
    "Reprocessamento de pontos iniciado": "Reprocesamiento de puntos iniciado",
    "Rua/Avenida/Logradouro": "Calle/Avenida",
    "Saldo Parcial": "Saldo Parcial",
    "Sem grupo": "Sin grupo",
    "Situação": "Situación",
    "Sorteio:": "Sorteo:",
    "Status atualizado em": "Estado actualizado el",
    "Série do cupom": "Serie del cupón",
    "Tokens": "Tokens",
    "Usuário não possui números": "El usuario no posee números",
    "Validade:": "Validez:",
    "Vence em:": "Vence el:",
    "Veículos": "Vehículos",
    "Volume": "Volumen",
    "anotado por": "anotado por",
    "toggle password visibility": "alternar visibilidad de la contraseña",
};

export default catalogo;
